import i18n from '@/helper/i18n';

export default function formatBnetStatus(value) {
  return i18n.te(`bnetStatusOptions.${value}`) ? i18n.t(`bnetStatusOptions.${value}.title`) : '';
}
